import { Button, Stack, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';

import { ProgressDots } from '@/components/DataDisplay/Indicator/ProgressDots';
import { Logo } from '@/components/Icon/Logo';
import { ActionBar } from '@/components/Layout';
import { Screen } from '@/components/Layout/Screen';

import { useAppSelector } from '@/hooks/redux';
import { useTranslate } from '@/hooks/useTranslate';

import { selectConfigsState } from '@/redux/configs';

import { getDataTestId } from '@/utils/browser';
import { PROGRESS_STEPS } from '@/utils/progressSteps';

import { useHandleThirdPartyComplianceCheck } from '../hooks';
import { ThirdPartyComplianceCheckImage } from './styles';

const ThirdPartyComplianceCheckScreenComponent: React.FC = () => {
  const { t } = useTranslate();
  const { logo } = useAppSelector(selectConfigsState);

  const { handleYesClick, handleNoClick, isPending, personalUseQuestion } =
    useHandleThirdPartyComplianceCheck();

  return (
    <Screen
      header={{
        centerSlot: (
          <ProgressDots
            value={PROGRESS_STEPS.thirdPartyComplianceCheckStep.value}
            total={PROGRESS_STEPS.thirdPartyComplianceCheckStep.total}
          />
        ),
      }}
      bgColor={(theme: Theme) => theme.palette.background.paper}
    >
      <Logo src={logo} alt="Logo" />
      <Stack direction="column" gap={10} flex={1}>
        <Typography variant="h4" textAlign="center" mb={1}>
          {personalUseQuestion?.question}
        </Typography>
        <ThirdPartyComplianceCheckImage />
      </Stack>
      <ActionBar>
        <Button
          {...getDataTestId(`third-party-use-yes-button`)}
          variant="outlined"
          fullWidth
          onClick={() => handleYesClick()}
          disabled={isPending}
        >
          {t('questionDrawer.personalUsage.button.yes')}
        </Button>
        <Button
          {...getDataTestId(`third-party-use-no-button`)}
          variant="outlined"
          fullWidth
          onClick={() => handleNoClick()}
          disabled={isPending}
        >
          {t('questionDrawer.personalUsage.button.no')}
        </Button>
      </ActionBar>
    </Screen>
  );
};

export default function ThirdPartyComplianceCheckScreen() {
  return <ThirdPartyComplianceCheckScreenComponent />;
}
